import { render, staticRenderFns } from "./PopupRight.vue?vue&type=template&id=1f5976f2&scoped=true"
import script from "./PopupRight.vue?vue&type=script&lang=js"
export * from "./PopupRight.vue?vue&type=script&lang=js"
import style0 from "./PopupRight.vue?vue&type=style&index=0&id=1f5976f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5976f2",
  null
  
)

export default component.exports